import { useCallback } from 'react';
import { useUnit } from 'effector-react';
import { Button, ButtonSize, ButtonType } from '@nx-frontend/shared/ui/button';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { webnotesThemeColors, webnotesThemeStyle } from '@nx-frontend/shared/themes/webnotes';
import { confirmSubscriptionEvent, showErrorDialogEvent } from './store';

export const PaywallErrorDialog = () => {
  const [showErrorDialog, confirmSubscription] = useUnit([showErrorDialogEvent, confirmSubscriptionEvent]);
  const handleClose = useCallback(() => {
    showErrorDialog(false);
  }, [showErrorDialog]);
  return (
    <div className="fixed left-0 top-0 flex items-center justify-center z-[1000] bg-black bg-opacity-20 w-full h-full">
      <div className="relative bg-white shadow-lg rounded-lg w-[405px] h-[238px] py-6 px-5 flex justify-center">
        <button className="absolute right-4 top-4" onClick={handleClose}>
          <Icon icon={IconsMap.CLOSE} className="w-4 text-black text-opacity-60" />
        </button>
        <div className="text-center w-full">
          <div className="mb-5">
            <span className="inline-flex items-center justify-center w-9 h-9 bg-red-100 rounded-full flex-shrink-0">
              <Icon icon={IconsMap.ALERT_CIRCLE} className="text-red-500 w-5 h-5" />
            </span>
          </div>
          <div className="font-semibold text-lg mb-1">Payment Failed</div>
          <div className="text-base mb-6">
            We couldn't process your payment.
            <br />
            Please try again or{' '}
            <a
              href={`https://thefusebase.com/support`}
              rel="noreferrer"
              target="_blank"
              className="font-bold text-cyan-900 underline"
            >
              contact support
            </a>
            .
          </div>
          <div className="flex justify-end">
            <Button
              type={ButtonType.FLAT}
              size={ButtonSize.MD}
              onClick={confirmSubscription}
              themeColors={webnotesThemeColors}
              themeStyle={webnotesThemeStyle}
              className="w-[120px] h-[30px]"
            >
              Got it
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
